"use client";

import { buildRequestHeaders } from "@datocms/cda-client";
import { createContext, useContext, useMemo } from "react";
import { cacheExchange, Client, fetchExchange, Provider } from "urql";

import { env } from "~/env";

// Dato CMS Client
const datoClient = new Client({
  url: "https://graphql.datocms.com",
  exchanges: [cacheExchange, fetchExchange],
  fetchOptions: {
    headers: buildRequestHeaders({
      token: env.NEXT_PUBLIC_DATOCMS_API_TOKEN,
      includeDrafts: env.NEXT_PUBLIC_VERCEL_URL !== "www.triptojapan.com",
      excludeInvalid: true,
      returnCacheTags: false,
    }),
  },
});

// Context for Bokun client
export const BokunClientContext = createContext<Client | null>(null);

export function useBokunClient() {
  const client = useContext(BokunClientContext);
  if (!client) {
    throw new Error(
      "Bokun client not available. Pass bokunConfig from server component.",
    );
  }
  return client;
}

export function UrqlProvider({
  children,
  bokunEnv,
}: {
  children: React.ReactNode;
  bokunEnv: {
    host: string;
    accessToken: string;
  };
}) {
  const bokunClient = useMemo(
    () =>
      new Client({
        url: `https://${bokunEnv.host}/api/graphql`,
        exchanges: [cacheExchange, fetchExchange],
        fetchOptions: {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Bokun-App-Access-Token": bokunEnv.accessToken,
          },
        },
      }),
    [bokunEnv.host, bokunEnv.accessToken],
  );

  return (
    <Provider value={datoClient}>
      <BokunClientContext value={bokunClient}>{children}</BokunClientContext>
    </Provider>
  );
}
